console.log("ga-custom-events.js loaded");

document.addEventListener(
  "click",
  /** @param {MouseEvent} event */ (event) => {
    if (event.target && event.target.name === "add") {
      if (!Shopify.analytics) {
        console.log("Shopify.analytics is not available");
        return;
      }

      const targetForm = event.target.closest("form");
      let formInputs;
      let productId;
      let variantId;
      if (targetForm) {
        formInputs = Array.from(targetForm.querySelectorAll("input"));
        productId = formInputs.find(
          (input) => input.name === "product-id"
        ).value;
        variantId = formInputs.find((input) => input.name === "id").value;
      }
      console.log("formInputs", formInputs);
      console.log("productId", productId);
      console.log("variantId", variantId);

      const source = event.target.dataset.buttonLocation || "unknown";

      const payload = {
        source,
        productId,
        variantId,
      };

      console.log("publishing payload: ", payload);
      Shopify.analytics.publish("kn_add_to_cart", payload);
    }
  }
);
